import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalService } from '../services/global.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipIntercept = req.headers.has('skip');
    if (skipIntercept) {
      req = req.clone({
          headers: req.headers.delete('skip')
      });
      return next.handle(req);
    }
    req = req.clone({
      setHeaders: {
        'Authorization': `Bearer ${inject(GlobalService).getIdToken() || ''}`,
      },
    });
    return next.handle(req);
  }
}